import { type ReactElement } from 'react'
import { useParams } from 'react-router-dom'
import WarningAmberIcon from '@mui/icons-material/WarningAmber'
import { Box, Tooltip } from '@mui/material'
import useResultsSectionOpen from '@editor/pages/Results2/hooks/useResultsSectionOpen'
import { useQuery } from '@tanstack/react-query'
import { Section } from '@ui2/structure'
import { getResultsValid } from '@queries'
import { CharacteristicSupportReactionsTable } from './CharacteristicSupportReactionsTable'

export const CharacteristicSupportReactionsSection = ({
  elementId,
}: {
  elementId?: string
}): ReactElement => {
  const { projectId } = useParams()

  const { data: resultsValid } = useQuery({
    queryKey: getResultsValid.getKey(projectId ?? ''),
    queryFn: () => getResultsValid.request(projectId!),
    enabled: Boolean(projectId),
    refetchInterval: 5000,
  })

  const showOutdatedWarning =
    resultsValid?.partially_valid === true && resultsValid?.fully_valid === false
  const charSupportReactionsSection = useResultsSectionOpen(
    'results2.design.characteristic-support-reactions',
  )

  return (
    <Section
      title="Charakteristische Auflagerkräfte je Lastfall (vertikal)"
      collapsible
      hideBorderBottom
      {...charSupportReactionsSection}
      actions={
        showOutdatedWarning ? (
          <Tooltip
            title="Ergebnisse vorhanden, aber Neu-Berechnung notwendig"
            arrow
            disableInteractive
          >
            <Box
              component="span"
              sx={{ display: 'inline-flex', alignItems: 'center' }}
              data-cy="characteristic-support-reactions-outdated-warning"
            >
              <WarningAmberIcon sx={{ fontSize: 18, color: 'warning.main' }} />
            </Box>
          </Tooltip>
        ) : null
      }
    >
      <CharacteristicSupportReactionsTable elementId={elementId} />
    </Section>
  )
}
